import _ from "lodash";

import { deepen } from "../utils/index.js";

export default () => () => action => ({
  ...action,
  ...(_.isNil(action.body) ? {} : { body: deepen(action.body) }),
});
